<template>
    <div v-if="dealer_type == 'brick_mortar'">
        <h2 class="headline-s form-headline-dealer-app">Retail Information</h2>
        <div class="notification-bar-wrapper-no-bg">
            <div class="drop-ship-banner">
                <span class="drop-ship-leftside">
                    <p class="title-s banner-title">
                        Retail Location
                    </p>
                    <span class="cta-wrapper">
                        <button 
                            type="button" 
                            :class="`${retailOption == 'add' ? 'small' : 'secondary small'} shipping-button-dealer-app${retailOption == 'add' ? '-selected' : ''}`"
                            @click="setRetailOption('add')">
                                Add Retail
                        </button>
                        <button
                            id="retail-address-same-as-mailing" 
                            type="button" 
                            :class="`${retailOption == 'mailing' ? 'small' : 'secondary small'} shipping-button-dealer-app${retailOption == 'mailing' ? '-selected' : ''}`"
                            @click="setRetailOption('mailing')">
                                Same As Mailing
                        </button>
                        <button
                            id="retail-address-same-as-shipping"  
                            type="button" 
                            :class="`${retailOption == 'shipping' ? 'small' : 'secondary small'} shipping-button-dealer-app${retailOption == 'shipping' ? '-selected' : ''}`"
                            @click="setRetailOption('shipping')">
                                Same As Shipping
                        </button>
                    </span>
                </span>
            </div>
        </div>
        <div class="form-headline-dealer-app" v-if="retailOption == 'mailing'">
            <p>Same as mailing address</p>
        </div>
        <div class="form-headline-dealer-app" v-else-if="retailOption == 'shipping'">
            <p>Same as shipping address</p>
        </div>
        <div v-else>
            <div class="field-type-dealer-app-full-width">
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="true"
                            id="retail_in_care_of" v-model="retail_in_care_of"
                            :class="{'invalid-state-input': errors.retail_in_care_of != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="retail_in_care_of" :class="{'invalid-state': errors.retail_in_care_of}">
                            <p>In Care Of *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.retail_in_care_of">{{ errors.retail_in_care_of }}</p></div>
                </div>
            </div>
            <div class="field-type-dealer-app">
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="true"
                            id="retail_address1" v-model="retail_address1"
                            :class="{'invalid-state-input': errors.retail_address1 != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="retail_address1" :class="{'invalid-state': errors.retail_address1}">
                            <p>Street 1 *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.retail_address1">{{ errors.retail_address1 }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            id="retail_address2" v-model="retail_address2"
                            :class="{'invalid-state-input': errors.retail_address2 != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="retail_address2" :class="{'invalid-state': errors.retail_address2}">
                            <p>Street 2</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.retail_address2">{{ errors.retail_address2 }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="requireStateCity"
                            id="retail_city" v-model="retail_city"
                            :class="{'invalid-state-input': errors.retail_city != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="retail_city" :class="{'invalid-state': errors.retail_city}">
                            <p>City {{requireStateCity ? '*' : ''}}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.retail_city">{{ errors.retail_city }}</p></div>
                </div>
                <div v-if="availableStates" class="field-state-dealer-app">
                    <custom-select
                        :aria-required="requireStateCity"
                        v-model="selectedState"
                        :label="`State/Province ${requireStateCity ? '*' : ''}`"
                        name="retail_state" 
                        id="retail_state" 
                        aria-label="Enter State/Province"
                        :options="formattedStates"
                    />
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.retail_state">{{ errors.retail_state }}</p></div>
                </div>
                <div v-if="!availableStates" class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="requireStateCity"
                            id="retail_state" v-model="retail_state"
                            :class="{'invalid-state-input': errors.retail_state != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="retail_state" :class="{'invalid-state': errors.retail_state}">
                            <p>State {{requireStateCity ? '*' : ''}}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.retail_state">{{ errors.retail_state }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="requireStateCity"
                            id="retail_zip_code" v-model="retail_zip_code"
                            :class="{
                                'invalid-state-input': errors.retail_zip_code != null
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label for="retail_zip_code" :class="{'invalid-state': errors.retail_zip_code}">
                            <p>Zip/Postal Code {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.retail_zip_code">{{ errors.retail_zip_code }}</p></div>
                </div>
                <div class="field-state-dealer-app">
                    <custom-select
                        :aria-required="true"
                        v-model="selectedCountry"
                        label="Country *"
                        name="retail_country" 
                        id="retail_country" 
                        aria-label="Enter Country"
                        :options="formattedCountries"
                    />
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.retail_country">{{ errors.retail_country }}</p></div>
                </div>
            </div>
            <AddressValidationMessage
                class="field-state-dealer-app"
                :street1="retail_address1"
                :street2="retail_address2"
                :city="retail_city"
                :state="retail_state"
                :postal_code="retail_zip_code"
                :country="retail_country"
                @useSuggestedAddress="useSuggestedShippingAddress"
            />
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, ref, watch } from "vue";
    import InputText from "primevue/inputtext";
    import AddressValidationMessage from "@/components/AddressValidationMessage.vue";
    let retail_in_care_of = defineModel("retail_in_care_of", {type: String, default: ''});
    let retail_address1 = defineModel("retail_address1", {type: String, default: ''});
    let retail_address2 = defineModel("retail_address2", {type: String, default: ''});
    let retail_city = defineModel("retail_city", {type: String, default: ''});
    let retail_country = defineModel("retail_country", {type: String, default: ''});
    let retail_state = defineModel("retail_state", {type: String, default: ''});
    let retail_zip_code = defineModel("retail_zip_code", {type: String, default: ''});
    let dealer_type = defineModel("dealer_type", {type: String, default: ''});
    let retailOption = defineModel("retailOption", {type: String, default: ''});
    let errors = defineModel("errors", {
        type: Object,
        default(){
            return {};
        }
    });

    let props = defineProps({
        regions: {
            type: String,
            default: ''
        },
        countries: {
            type: Object,
            default(){
                return {};
            }
        }
    });

    let setRetailOption = (option) => {
        retailOption.value = option;
        if(option != 'add'){
            retail_in_care_of.value = '';
            retail_address1.value = '';
            retail_address2.value = '';
            retail_city.value = '';
            retail_country.value = '';
            retail_state.value = '';
            retail_zip_code.value = '';
        }
    };

    let availableStates = computed(()=>{
        return JSON.parse(props.regions)[retail_country.value];
    });

    let formattedCountries = computed(() => {
        return Object.entries(props.countries).map(([key, value]) => {
            return {
                key: key,
                value: value
            };
        });
    });
    let selectedCountry = computed({
        get(){
            return formattedCountries.value.find(currentCountry => currentCountry.key == retail_country.value) ?? {key: '', value: ''};
        },
        set(value){
            retail_country.value = value.key;
        }
    })
    let formattedStates = computed(()=>{
        return Object.entries(availableStates.value)?.map(([key, value]) => {
            return {
                key: key,
                value: value
            }
        });
    });
    let selectedState = computed({
        get(){
            return formattedStates.value.find(currentState => currentState.key == retail_state.value) ?? {key: '', value: ''};
        },
        set(value){
            retail_state.value = value.key;
        }
    });

    const requireStateCity = computed(()=>{
        return !!retail_country.value && ['US','CA'].includes(retail_country.value);
    })

    watch(retail_country, (newCountryValue, oldCountryValue) => {
        if (!['US', 'CA', 'PR'].includes(newCountryValue) && ['US', 'CA', 'PR'].includes(oldCountryValue)) {
            retail_state.value = '';
            return;
        }
        if (['US', 'CA', 'PR'].includes(newCountryValue)) {
            let state = retail_state.value.toLowerCase();
            let availableStateKeys = Object.keys(availableStates.value || {});

            let matchedState = availableStateKeys.find(
                key => availableStates.value[key].toLowerCase() === state || key.toLowerCase() === state
            );
            retail_state.value = matchedState ?? '';
        }
    });

    let useSuggestedShippingAddress = (suggestedAddress) => {
        retail_address1.value = suggestedAddress.street1;
        retail_address2.value = suggestedAddress.street2;
        retail_city.value = suggestedAddress.city;
        retail_state.value = suggestedAddress.state;
        retail_zip_code.value = suggestedAddress.postal_code;
        retail_country.value = suggestedAddress.country == 'USA' ? 'US' : suggestedAddress.country;
    };
</script>